import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Input } from 'reactstrap';
import './index.scss';

const SearchBlock2 = ({placeholder, onSearchChange, resetValue}) => {
	const inputRef = React.useRef(null);

    React.useEffect(() => {
        if (resetValue) {
            inputRef.current.value = '';
        }
    }, [resetValue]);
	return (
		<div className='search-blc2 position-relative'>
			<Input type="text" placeholder={placeholder!=null ? placeholder: "Search File by: name, date, size etc."}
			onChange={(e) => onSearchChange(e.target.value)}
			innerRef={inputRef}
			/>
			<span className='position-absolute d-inline-flex align-items-center justify-content-center'>
				<FontAwesomeIcon icon={faSearch} />
			</span>
		</div>
	);
}

export default SearchBlock2;